
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';

/**
 * DesiredAppSettingsGetResponse struct
 */
class DesiredAppSettingsGetResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {string=} latestApkFileUrl
   * @param {string=} latestAppVersion
   * @param {number=} nonForceUpdateTimeInterval
   * @constructor
   */
  constructor (parent = new Response(), latestApkFileUrl = null, latestAppVersion = null, nonForceUpdateTimeInterval = null) {
    super()
    super.copy(parent)
    this.LatestApkFileUrl = latestApkFileUrl
    this.LatestAppVersion = latestAppVersion
    this.NonForceUpdateTimeInterval = nonForceUpdateTimeInterval
  }

  /**
   * Copy struct (shallow copy)
   * @this {!DesiredAppSettingsGetResponse}
   * @param {!DesiredAppSettingsGetResponse} other Other struct
   * @returns {!DesiredAppSettingsGetResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.LatestApkFileUrl != null) {
      this.LatestApkFileUrl = other.LatestApkFileUrl
    } else {
      this.LatestApkFileUrl = null
    }
    if (other.LatestAppVersion != null) {
      this.LatestAppVersion = other.LatestAppVersion
    } else {
      this.LatestAppVersion = null
    }
    if (other.NonForceUpdateTimeInterval != null) {
      this.NonForceUpdateTimeInterval = other.NonForceUpdateTimeInterval
    } else {
      this.NonForceUpdateTimeInterval = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!DesiredAppSettingsGetResponse}
   * @returns {!DesiredAppSettingsGetResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new DesiredAppSettingsGetResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new DesiredAppSettingsGetResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!DesiredAppSettingsGetResponse}
   * @param {!DesiredAppSettingsGetResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof DesiredAppSettingsGetResponse)) {
      throw new TypeError('Instance of DesiredAppSettingsGetResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!DesiredAppSettingsGetResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      LatestApkFileUrl: ((this.LatestApkFileUrl != null) ? this.LatestApkFileUrl : null),
      LatestAppVersion: ((this.LatestAppVersion != null) ? this.LatestAppVersion : null),
      NonForceUpdateTimeInterval: ((this.NonForceUpdateTimeInterval != null) ? this.NonForceUpdateTimeInterval : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return DesiredAppSettingsGetResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!DesiredAppSettingsGetResponse} other Object value
   * @returns {!DesiredAppSettingsGetResponse} Created struct
   */
  static fromObject (other) {
    return new DesiredAppSettingsGetResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!DesiredAppSettingsGetResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return DesiredAppSettingsGetResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!DesiredAppSettingsGetResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5543
  }
}

export { DesiredAppSettingsGetResponse };

/**
 * Fast Binary Encoding DesiredAppSettingsGetResponse field model
 */
class FieldModelDesiredAppSettingsGetResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.LatestApkFileUrl = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.LatestAppVersion = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.LatestApkFileUrl.fbeOffset + this.LatestApkFileUrl.fbeSize), buffer, this.LatestApkFileUrl.fbeOffset + this.LatestApkFileUrl.fbeSize)
    this.NonForceUpdateTimeInterval = new fbe.FieldModelOptional(new fbe.FieldModelUInt32(buffer, this.LatestAppVersion.fbeOffset + this.LatestAppVersion.fbeSize), buffer, this.LatestAppVersion.fbeOffset + this.LatestAppVersion.fbeSize)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.LatestApkFileUrl.fbeSize + this.LatestAppVersion.fbeSize + this.NonForceUpdateTimeInterval.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.LatestApkFileUrl.fbeExtra + this.LatestAppVersion.fbeExtra + this.NonForceUpdateTimeInterval.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelDesiredAppSettingsGetResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5543
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.LatestApkFileUrl.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LatestApkFileUrl.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LatestApkFileUrl.fbeSize

    if ((fbeCurrentSize + this.LatestAppVersion.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LatestAppVersion.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LatestAppVersion.fbeSize

    if ((fbeCurrentSize + this.NonForceUpdateTimeInterval.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NonForceUpdateTimeInterval.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NonForceUpdateTimeInterval.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @param {!DesiredAppSettingsGetResponse} fbeValue Default value, defaults is new DesiredAppSettingsGetResponse()
   * @returns {!DesiredAppSettingsGetResponse} DesiredAppSettingsGetResponse value
   */
  get (fbeValue = new DesiredAppSettingsGetResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @param {!DesiredAppSettingsGetResponse} fbeValue DesiredAppSettingsGetResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.LatestApkFileUrl.fbeSize) <= fbeStructSize) {
      fbeValue.LatestApkFileUrl = this.LatestApkFileUrl.get()
    } else {
      fbeValue.LatestApkFileUrl = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LatestApkFileUrl.fbeSize

    if ((fbeCurrentSize + this.LatestAppVersion.fbeSize) <= fbeStructSize) {
      fbeValue.LatestAppVersion = this.LatestAppVersion.get()
    } else {
      fbeValue.LatestAppVersion = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LatestAppVersion.fbeSize

    if ((fbeCurrentSize + this.NonForceUpdateTimeInterval.fbeSize) <= fbeStructSize) {
      fbeValue.NonForceUpdateTimeInterval = this.NonForceUpdateTimeInterval.get()
    } else {
      fbeValue.NonForceUpdateTimeInterval = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NonForceUpdateTimeInterval.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @param {!DesiredAppSettingsGetResponse} fbeValue DesiredAppSettingsGetResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelDesiredAppSettingsGetResponse}
   * @param {DesiredAppSettingsGetResponse} fbeValue DesiredAppSettingsGetResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.LatestApkFileUrl.set(fbeValue.LatestApkFileUrl)
    this.LatestAppVersion.set(fbeValue.LatestAppVersion)
    this.NonForceUpdateTimeInterval.set(fbeValue.NonForceUpdateTimeInterval)
  }
}

export { FieldModelDesiredAppSettingsGetResponse };

/**
 * Fast Binary Encoding DesiredAppSettingsGetResponse model
 */
class DesiredAppSettingsGetResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelDesiredAppSettingsGetResponse(this.buffer, 4)
  }

  /**
   * Get the DesiredAppSettingsGetResponse model
   * @this {!DesiredAppSettingsGetResponseModel}
   * @returns {!FieldModelDesiredAppSettingsGetResponse} model DesiredAppSettingsGetResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!DesiredAppSettingsGetResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!DesiredAppSettingsGetResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return DesiredAppSettingsGetResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!DesiredAppSettingsGetResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelDesiredAppSettingsGetResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!DesiredAppSettingsGetResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!DesiredAppSettingsGetResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!DesiredAppSettingsGetResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!DesiredAppSettingsGetResponseModel}
   * @param {!DesiredAppSettingsGetResponse} value DesiredAppSettingsGetResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!DesiredAppSettingsGetResponseModel}
   * @param {!DesiredAppSettingsGetResponse} value DesiredAppSettingsGetResponse value, defaults is new DesiredAppSettingsGetResponse()
   * @return {!object} Deserialized DesiredAppSettingsGetResponse value and its size
   */
  deserialize (value = new DesiredAppSettingsGetResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new DesiredAppSettingsGetResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new DesiredAppSettingsGetResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!DesiredAppSettingsGetResponseModel}
   * @param {!number} prev Previous DesiredAppSettingsGetResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { DesiredAppSettingsGetResponseModel };
